module.exports = __webpack_public_path__ + "img/logo.bdc80777.png";